
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/bookis",
      function () {
        return require("private-next-pages/success-stories/bookis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/bookis"])
      });
    }
  